import React from "react";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";
import "./Dashboard.css";

function DashboardLayout() {
  return (
    <>
      <div className="flex gap-4">
        <SideBar />
        <Outlet />
      </div>
    </>
  );
}

export default DashboardLayout;
